import { useFormContext } from 'react-hook-form';

import { OmBoligenFormData } from './types';

export const useOmBoligenFormContext = () => {
  return useFormContext<OmBoligenFormData>();
};
